import React from "react"

export const CityIcon: React.FunctionComponent = () => (
  <svg viewBox="0 0 480 480">
    <path d="m216 32h16v16h-16zm0 0" />
    <path d="m248 32h16v16h-16zm0 0" />
    <path d="m216 64h16v16h-16zm0 0" />
    <path d="m248 64h16v16h-16zm0 0" />
    <path d="m216 96h16v16h-16zm0 0" />
    <path d="m248 96h16v16h-16zm0 0" />
    <path d="m216 128h16v16h-16zm0 0" />
    <path d="m248 128h16v16h-16zm0 0" />
    <path d="m216 160h16v16h-16zm0 0" />
    <path d="m248 160h16v16h-16zm0 0" />
    <path d="m216 192h16v16h-16zm0 0" />
    <path d="m248 192h16v16h-16zm0 0" />
    <path d="m216 224h16v16h-16zm0 0" />
    <path d="m248 224h16v16h-16zm0 0" />
    <path d="m216 256h16v16h-16zm0 0" />
    <path d="m248 256h16v16h-16zm0 0" />
    <path d="m216 288h16v16h-16zm0 0" />
    <path d="m248 288h16v16h-16zm0 0" />
    <path d="m216 320h16v16h-16zm0 0" />
    <path d="m248 320h16v16h-16zm0 0" />
    <path d="m216 352h16v16h-16zm0 0" />
    <path d="m248 352h16v16h-16zm0 0" />
    <path d="m216 384h16v16h-16zm0 0" />
    <path d="m248 384h16v16h-16zm0 0" />
    <path d="m216 416h16v16h-16zm0 0" />
    <path d="m248 416h16v16h-16zm0 0" />
    <path d="m312 160h16v16h-16zm0 0" />
    <path d="m312 192h16v16h-16zm0 0" />
    <path d="m312 224h16v16h-16zm0 0" />
    <path d="m312 256h16v16h-16zm0 0" />
    <path d="m312 288h16v16h-16zm0 0" />
    <path d="m312 320h16v16h-16zm0 0" />
    <path d="m312 352h16v16h-16zm0 0" />
    <path d="m312 384h16v16h-16zm0 0" />
    <path d="m312 416h16v16h-16zm0 0" />
    <path d="m152 160h16v16h-16zm0 0" />
    <path d="m152 192h16v16h-16zm0 0" />
    <path d="m152 224h16v16h-16zm0 0" />
    <path d="m152 256h16v16h-16zm0 0" />
    <path d="m152 288h16v16h-16zm0 0" />
    <path d="m152 320h16v16h-16zm0 0" />
    <path d="m152 352h16v16h-16zm0 0" />
    <path d="m152 384h16v16h-16zm0 0" />
    <path d="m152 416h16v16h-16zm0 0" />
    <path d="m456 88c0-4.417969-3.582031-8-8-8h-8v-24c0-3.03125-1.710938-5.804688-4.425781-7.160156l-32-16c-2.25-1.125-4.898438-1.125-7.148438 0l-32 16c-2.714843 1.355468-4.425781 4.128906-4.425781 7.160156v24h-8c-4.417969 0-8 3.582031-8 8v40h-16v-72c0-4.417969-3.582031-8-8-8h-24v-40c0-4.417969-3.582031-8-8-8h-96c-4.417969 0-8 3.582031-8 8v40h-24c-4.417969 0-8 3.582031-8 8v72h-16v-40c0-4.417969-3.582031-8-8-8h-8v-24c0-4.417969-3.582031-8-8-8h-24v-16h-16v16h-24c-4.417969 0-8 3.582031-8 8v24h-8c-4.417969 0-8 3.582031-8 8v376h-24v16h480v-16h-24zm-400-24h48v16h-48zm64 48h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-80v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h80zm64 352h-16v-16h-16v16h-16v-320h48zm0-336h-16v-64h16zm96-72v408h-16v-16h-16v16h-16v-16h-16v16h-16v-448h80zm16 8h16v64h-16zm48 400h-16v-16h-16v16h-16v-320h48zm32-403.054688 24-12 24 12v19.054688h-48zm32 403.054688h-16v-16h16zm32 0h-16v-24c0-4.417969-3.582031-8-8-8h-32c-4.417969 0-8 3.582031-8 8v24h-16v-368h80zm0 0" />
    <path d="m376 112h16v24h-16zm0 0" />
    <path d="m408 112h16v24h-16zm0 0" />
    <path d="m376 152h16v24h-16zm0 0" />
    <path d="m408 152h16v24h-16zm0 0" />
    <path d="m376 192h16v24h-16zm0 0" />
    <path d="m408 192h16v24h-16zm0 0" />
    <path d="m376 232h16v24h-16zm0 0" />
    <path d="m408 232h16v24h-16zm0 0" />
    <path d="m376 272h16v24h-16zm0 0" />
    <path d="m408 272h16v24h-16zm0 0" />
    <path d="m376 312h16v24h-16zm0 0" />
    <path d="m408 312h16v24h-16zm0 0" />
    <path d="m376 352h16v24h-16zm0 0" />
    <path d="m408 352h16v24h-16zm0 0" />
    <path d="m376 392h16v24h-16zm0 0" />
    <path d="m408 392h16v24h-16zm0 0" />
    <path d="m72 112h16v16h-16zm0 0" />
    <path d="m72 144h16v16h-16zm0 0" />
    <path d="m72 176h16v16h-16zm0 0" />
    <path d="m72 208h16v16h-16zm0 0" />
    <path d="m72 240h16v16h-16zm0 0" />
    <path d="m72 272h16v16h-16zm0 0" />
    <path d="m72 304h16v16h-16zm0 0" />
    <path d="m72 336h16v16h-16zm0 0" />
    <path d="m72 368h16v16h-16zm0 0" />
    <path d="m72 400h16v16h-16zm0 0" />
    <path d="m72 432h16v16h-16zm0 0" />
  </svg>
)
